import React from 'react';
import { Translation } from 'react-i18next';
import {
  IconFilter,
  FilterSelectComponent,
} from 'nallian-shared-ui/lib/components/semantic-filter-components';

const POTENTIAL_DUPLICATE_OPTIONS = [
  {
    key: true,
    value: 1,
    text: <Translation>{t => t('potentialDuplicate')}</Translation>,
  },
  {
    key: false,
    value: 0,
    text: <Translation>{t => t('new')}</Translation>,
  },
];

const PotentialDuplicateFilter = () => (
  <IconFilter
    hasApplyButton
    name="isPotentialDuplicate"
    position="bottom right"
    placement="bottom-end"
    as={FilterSelectComponent}
    options={POTENTIAL_DUPLICATE_OPTIONS}
  />
);

export default PotentialDuplicateFilter;
